import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { Space } from 'antd';

export const MainContainer = styled(Space)`
  ${breakpoint('tablet')`
    max-width: 600px;
  `}
`;

export const MarkdownContainer = styled.div`
  width: 100%;
  text-align: left;
`;
